import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import HomeView from "@/pages/HomeView";
import LandingPage from "@/pages/LandingPage";
import MapsView from "@/pages/MapsView";
import MapView from "@/pages/MapView";
import IotView from "@/pages/IotView";
import DetailsView from "@/pages/DetailsView";
import ItemForm from "@/pages/ItemForm";
import TestMap from "@/pages/TestMap";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <Routes>
            {/* New root experience */}
            <Route path="/" element={<HomeView />} />

            {/* Previous app, archived under /old */}
            <Route path="/old" element={<LandingPage />} />
            <Route path="/old/map" element={<MapsView />} />
            <Route path="/old/iot" element={<IotView />} />
            <Route path="/old/admin" element={<MapView />} />
            <Route path="/old/test" element={<TestMap />} />
            <Route path="/old/item/:permid" element={<DetailsView />} />
            <Route path="/old/create" element={<ItemForm mode="create" />} />
            <Route path="/old/edit/:permid" element={<ItemForm mode="edit" />} />

            {/* Backwards-compatible aliases so the old app's internal links keep working */}
            <Route path="/map" element={<MapsView />} />
            <Route path="/iot" element={<IotView />} />
            <Route path="/admin" element={<MapView />} />
            <Route path="/test" element={<TestMap />} />
            <Route path="/item/:permid" element={<DetailsView />} />
            <Route path="/create" element={<ItemForm mode="create" />} />
            <Route path="/edit/:permid" element={<ItemForm mode="edit" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </DataProvider>
    </AuthProvider>
  );
}
